/**
 * access_token in localStorage and AuthContext `user` may be either a raw JWT
 * (starts with "eyJ") or JSON.stringify(token) from some login paths.
 */
export function parseStoredAccessToken(stored) {
  if (stored == null || stored === '') return null;
  const s = typeof stored === 'string' ? stored : String(stored);
  try {
    const parsed = JSON.parse(s);
    return typeof parsed === 'string' ? parsed : null;
  } catch {
    return s;
  }
}
